module.exports = __webpack_public_path__ + "item_1.svg?cda9e96edaf41673642a50b3a0492d25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item_1.svg
// module id = 24
// module chunks = 0